export type EmissaoPayload = { ini: string; fim: string };

/**
 * Formata o range de emissão para 'YYYY-MM-DD' (sem horário), no fuso local.
 * @param range Objeto com ini e fim como Moment
 * @returns Objeto com ini e fim em 'YYYY-MM-DD'
 */
export const normalizeEmissao = (range: {
  ini: moment.Moment;
  fim: moment.Moment;
}): EmissaoPayload => ({
  ini: range.ini.format('YYYY-MM-DD'),
  fim: range.fim.format('YYYY-MM-DD'),
});
